import { useCallback } from 'react';

import { FCWithChildren } from 'common/types';
import Button from 'components/_core/Button';

interface ExternalButtonLinkProps {
  href: string;
}

const ExternalButtonLink: FCWithChildren<ExternalButtonLinkProps> = ({
  children,
  href,
}) => {
  const onClick = useCallback(() => {
    window.open(href, '_blank');
  }, [href]);
  return (
    <Button onClick={onClick} variant="inline-primary">
      {children}
    </Button>
  );
};

export default ExternalButtonLink;
